import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=17a68fca&scoped=true&"
import script from "./UserForm.vue?vue&type=script&lang=js&"
export * from "./UserForm.vue?vue&type=script&lang=js&"
import style0 from "../../assets/styles/shared-forms.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./UserForm.vue?vue&type=style&index=1&id=17a68fca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a68fca",
  null
  
)

export default component.exports